import { filter } from "rxjs";
// src/domain-events.ts
function filterEvents(type, $domainEvent) {
	return $domainEvent.pipe(filter((event) => event.type === type));
}
function addEventListener(eventSource, type, handler) {
	const parseAndHandle = ((event) => {
		const data = JSON.parse(event.data);
		handler({
			...event,
			data
		});
	});
	eventSource.addEventListener(type, parseAndHandle);
}
// src/festival-activity.ts
const FESTIVAL_ACTIVITY_CREATED = "festival-activity-created";
const FESTIVAL_ACTIVITY_READY_TO_REVIEW = "festival-activity-ready-to-review";
const FESTIVAL_ACTIVITY_APPROVED = "festival-activity-approved";
const FESTIVAL_ACTIVITY_REJECTED = "festival-activity-rejected";
var FestivalActivity = class FestivalActivity {
	static created(festivalActivity, by) {
		const data = {
			festivalActivity,
			by,
			at: FestivalActivity.computeAt(),
			id: festivalActivity.id
		};
		return {
			type: FESTIVAL_ACTIVITY_CREATED,
			data
		};
	}
	static readyToReview(festivalActivity, by) {
		const data = {
			festivalActivity,
			by,
			at: FestivalActivity.computeAt(),
			id: festivalActivity.id
		};
		return {
			type: FESTIVAL_ACTIVITY_READY_TO_REVIEW,
			data
		};
	}
	static approved(festivalActivity, by) {
		const data = {
			festivalActivity,
			by,
			at: FestivalActivity.computeAt(),
			id: festivalActivity.id
		};
		return {
			type: FESTIVAL_ACTIVITY_APPROVED,
			data
		};
	}
	static rejected(festivalActivity, by, reason) {
		const data = {
			festivalActivity,
			by,
			at: FestivalActivity.computeAt(),
			id: festivalActivity.id,
			reason
		};
		return {
			type: FESTIVAL_ACTIVITY_REJECTED,
			data
		};
	}
	static computeAt() {
		const at = /* @__PURE__ */ new Date();
		at.setMilliseconds(0);
		return at;
	}
};
// src/festival-task.ts
const FESTIVAL_TASK_CREATED = "festival-task-created";
const FESTIVAL_TASK_READY_TO_REVIEW = "festival-task-ready-to-review";
const FESTIVAL_TASK_REJECTED = "festival-task-rejected";
const FESTIVAL_TASK_APPROVED = "festival-task-approved";
const FESTIVAL_TASK_IGNORED = "festival-task-ignored";
const FESTIVAL_TASK_DO_REVIEW = "festival-task-do-review";
const FESTIVAL_TASK_READY_TO_ASSIGN = "festival-task-ready-to-assign";
var FestivalTask = class FestivalTask {
	static created(festivalTask, by) {
		const data = {
			festivalTask,
			by,
			at: FestivalTask.computeAt(),
			id: festivalTask.id
		};
		return {
			type: FESTIVAL_TASK_CREATED,
			data
		};
	}
	static readyToReview(festivalTask, by) {
		const data = {
			festivalTask,
			by,
			at: FestivalTask.computeAt(),
			id: festivalTask.id
		};
		return {
			type: FESTIVAL_TASK_READY_TO_REVIEW,
			data
		};
	}
	static rejected(festivalTask, by, reason) {
		const data = {
			festivalTask,
			by,
			at: FestivalTask.computeAt(),
			id: festivalTask.id,
			reason
		};
		return {
			type: FESTIVAL_TASK_REJECTED,
			data
		};
	}
	static approved(festivalTask, by) {
		const data = {
			festivalTask,
			by,
			at: FestivalTask.computeAt(),
			id: festivalTask.id
		};
		return {
			type: FESTIVAL_TASK_APPROVED,
			data
		};
	}
	static ignored(festivalTask, by) {
		const data = {
			festivalTask,
			by,
			at: FestivalTask.computeAt(),
			id: festivalTask.id
		};
		return {
			type: FESTIVAL_TASK_IGNORED,
			data
		};
	}
	static doReview(festivalTask, by) {
		const data = {
			festivalTask,
			by,
			at: FestivalTask.computeAt(),
			id: festivalTask.id
		};
		return {
			type: FESTIVAL_TASK_DO_REVIEW,
			data
		};
	}
	static readyToAssign(festivalTask, by) {
		const data = {
			festivalTask,
			by,
			at: FestivalTask.computeAt(),
			id: festivalTask.id
		};
		return {
			type: FESTIVAL_TASK_READY_TO_ASSIGN,
			data
		};
	}
	static computeAt() {
		const at = /* @__PURE__ */ new Date();
		at.setMilliseconds(0);
		return at;
	}
};
// src/shared-meal.ts
const SHARED_MEAL_CLOSED = "shared-meal-closed";
// src/registration.ts
const STAFF_REGISTERED = "staff-registered";
const VOLUNTEER_REGISTERED = "volunteer-registered";
export { FESTIVAL_ACTIVITY_APPROVED, FESTIVAL_ACTIVITY_CREATED, FESTIVAL_ACTIVITY_READY_TO_REVIEW, FESTIVAL_ACTIVITY_REJECTED, FESTIVAL_TASK_APPROVED, FESTIVAL_TASK_CREATED, FESTIVAL_TASK_DO_REVIEW, FESTIVAL_TASK_IGNORED, FESTIVAL_TASK_READY_TO_ASSIGN, FESTIVAL_TASK_READY_TO_REVIEW, FESTIVAL_TASK_REJECTED, FestivalActivity, FestivalTask, SHARED_MEAL_CLOSED, STAFF_REGISTERED, VOLUNTEER_REGISTERED, addEventListener, filterEvents };

//# sourceMappingURL=index.mjs.map